import api from "./httpService";


export const renewService = async (payload: Record<string, unknown>) => {
    const response = await api.post('/renew', payload);
    return response.data;
}

export type SubscriptionScope = "thisMonth" | "old";

export const getSubscriptions = async ({
    scope,
    page = 1,
    limit = 10,
    search = "",
    type,
    packageId,
    startDate,
    endDate,
}: {
    scope?: SubscriptionScope;
    page?: number;
    limit?: number;
    search?: string;
    type?: string;
    packageId?: string | string[];
    startDate?: string;
    endDate?: string;
}) => {
    const params = new URLSearchParams({
        page: String(page),
        limit: String(limit),
    });

    if (scope) params.set("scope", scope);
    if (search.trim()) params.set("search", search.trim());
    if (type?.trim()) params.set("type", type.trim());
    if (startDate?.trim()) params.set("startDate", startDate.trim());
    if (endDate?.trim()) params.set("endDate", endDate.trim());
    if (Array.isArray(packageId)) {
        const packageIds = packageId.map((id) => id.trim()).filter(Boolean);
        packageIds.forEach((id) => params.append("packageId", id));
    } else if (packageId?.trim()) {
        params.set("packageId", packageId.trim());
    }

    const response = await api.get(`/renew?${params.toString()}`);
    return response.data;
}

export const notifySubscription = async (subscriptionId: string, notify = true) => {
    const response = await api.put(`/renew/${subscriptionId}/notify`, { notify });
    return response.data;
}

export const deleteSubscription = async (subscriptionId: string) => {
    const response = await api.delete(`/renew/${subscriptionId}`);
    return response.data;
}

export const getRenewStats = async (days = 5, year?: number | string) => {
    const params = new URLSearchParams({ days: String(days) });
    if (year) params.set("year", String(year));

    const response = await api.get(`/renew/stats?${params.toString()}`);
    return response.data;
}
